import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SpinnerIcon } from '@/components/icons';
import { useWorkspace } from '@/features/workspaces/hooks';
import { isEmpty } from 'lodash';
import { useGetRulesQuery } from '@/services/endpoints/rules';
import { useSelector } from 'react-redux';
import { RootState } from '@/reducers';
import { ExpressionCondition } from '@/models/audiences';

interface IEventValueProps {
  ruleId?: string;
  type?: 'TRACK' | 'VIEW';
  expressionKind: ExpressionCondition['kind'];
}

export const EventValue: FC<IEventValueProps> = ({ ruleId, type, expressionKind }) => {
  const { t } = useTranslation('audience');
  const workspace = useWorkspace();
  const audience = useSelector((state: RootState) => state.audienceEdit.audience);

  const { isLoading, data } = useGetRulesQuery({
    workspaceId: workspace.id,
    type,
    datasourceIds: audience?.datasourceIds,
  });

  const rules = data || [];
  const rule = rules.find((a) => a.id === ruleId);

  if (!isLoading && isEmpty(rules)) {
    return (
      <div className='grid h-full place-content-center'>
        <p className='text-sm'>{t('rules.there_are_no_events')}</p>
      </div>
    );
  }

  const renderTraitName = () => {
    return isLoading ? <SpinnerIcon className='ml-2 size-4' loading /> : rule.name;
  };

  return (
    <p className='text-sm font-medium text-tertiary-600 first-letter:capitalize'>
      {expressionKind === 'EVENT' ? t('rules.have_performed') : t('rules.have_visited')} <span className='inline-block font-bold'>{renderTraitName()}</span>
    </p>
  );
};
